import React, { FC, useMemo } from "react";
import classnames from "classnames";
import moment from "moment";
import DatePickerOrigin, { DatePickerProps } from "rsuite/DatePicker";
import { RsRefForwardingComponent } from "rsuite/esm/@types/common";
import "./rsuite.css";
import "./rsuite.calendar.css";
import "./index.scss";

export interface ModifiedDatePickerProps extends Omit<DatePickerProps, "value"> {
  value?: Date | null;
}

const DatePicker = DatePickerOrigin as RsRefForwardingComponent<"div", ModifiedDatePickerProps>;
interface CustomDatePickerProps {
  className?: string;
  label?: string;
  placeholder?: string;
  onChange: (value: moment.Moment | null) => void;
  value?: moment.Moment | null;
  disablePast?: boolean;
  disabledDate?: (date?: Date) => boolean;
  calendarDefaultDate?: Date;
  disabled?: boolean;
  view?: "date" | "month" | "time";
  format?: string;
  showMeridian?: boolean;
  cleanable?: boolean;
}

const CustomDatePicker: FC<CustomDatePickerProps> = (props) => {
  const {
    className,
    label,
    onChange,
    value,
    disabled,
    cleanable,
    view = "date",
    format = "HH:mm aa",
    showMeridian = true,
    disablePast,
    disabledDate,
    placeholder,
    calendarDefaultDate,
  } = props;
  const pickerProperties: ModifiedDatePickerProps = useMemo(() => {
    const propObject: ModifiedDatePickerProps = {
      disabled,
      cleanable,
      value: value ? value.toDate() : null,
      onChange: (date: Date | null) => onChange(date ? moment(date) : null),
      ranges: [],
      className: "custom-datepicker-wrapper",
      disabledDate:
        disabledDate ||
        (disablePast ? (date: Date | undefined) => moment(date) < moment().subtract(1, "day") : undefined),
      placeholder,
      calendarDefaultDate,
    };

    switch (view) {
      case "date":
        propObject.menuClassName = "custom-datepicker-menu-date";
        propObject.format = "MM/dd/yyyy";
        propObject.onClean = () => {
          onChange(null);
        };
        break;
      case "month":
        propObject.menuClassName = "custom-datepicker-menu-month";
        propObject.format = "MMM, yyyy";
        propObject.size = "lg";
        break;
      case "time":
        propObject.menuClassName = "custom-datepicker-menu-time";
        propObject.format = format;
        propObject.showMeridian = showMeridian;
        propObject.placeholder = "00:00";
        propObject.onClean = () => {
          onChange(null);
        };
    }
    return propObject;
  }, [
    value,
    onChange,
    disabled,
    view,
    format,
    showMeridian,
    cleanable,
    disablePast,
    placeholder,
    disabledDate,
    calendarDefaultDate,
  ]);

  return (
    <div className={classnames("custom-datepicker input-wrapper", className, { disabled })}>
      {label && <label className="custom-input-label">{label}</label>}
      <DatePicker {...pickerProperties} placement="auto" />
    </div>
  );
};
export default CustomDatePicker;
